import { Heading, Text } from "@/src/components/ui/Typography";

import type { StatItemData } from "./StatRow.types";

interface StatItemProps {
  item: StatItemData;
}

export function StatItem({ item }: StatItemProps) {
  return (
    <div>
      <Heading as="h3" size="displayLG" className="text-neutral-700">
        {item.value}
      </Heading>

      <Text size="bodySM" className="mt-1 text-neutral-500">
        {item.label}
      </Text>
    </div>
  );
}
